import { render, staticRenderFns } from "./FriendshipRequestMessage.vue?vue&type=template&id=d27b3222&"
import script from "./FriendshipRequestMessage.vue?vue&type=script&lang=js&"
export * from "./FriendshipRequestMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports